/** skyx_new i18n namespace (game bundle registers locales under this id). */
export const SKYX_NEW_NS = 'skyx_new';
